import type { CSSProperties } from "react";

export const BRAND = "#0F9599";
export const BRAND_DARK = "#0B7377";
export const BRAND_DEEP = "#0E4B4D";
export const NIGHT = "#0E3B3A";
export const NIGHT_2 = "#124A47";
export const MINT = "#2FE3BE";
export const ORANGE = "#F2994A";
export const RED = "#EB5757";
export const TEAL = "#0F9599";
export const TEXT_INK = "#0E2A2A";
export const TEXT_DARK = "#5A6970";
export const TEXT_DIM = "#9CA3AF";
export const TEXT_DIM_ON_DARK = "rgba(240, 250, 248, 0.65)";
export const BG_PAGE = "#FFFFFF";
export const BG_SOFT = "#F7F9F9";
export const BORDER = "#E5E7EB";
export const BORDER_ON_DARK = "rgba(255, 255, 255, 0.12)";
export const FONT_STACK = "'Plus Jakarta Sans', 'Inter', system-ui, sans-serif";

export const CONTAINER: CSSProperties = { maxWidth: 1240, margin: "0 auto", padding: "0 28px" };